import { AccessGuard } from '@/components/layout/access-guard'

export function ProtectedPortalRoute() {
  return (
    <AccessGuard
      routeId="portal.root"
      deniedTitle="HR Portal access required"
      deniedMessage="This account is valid, but it cannot access this organization portal."
    />
  )
}
